var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.876,
    height: 58.876,
    viewBox: "0 0 58.876 58.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_580",
    x: 0,
    y: 0,
    width: 58.876,
    height: 58.876,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7230",
    "data-name": "Group 7230",
    transform: "translate(9341.732 -9247.498)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9341.73, 9247.5)",
    filter: "url(#Ellipse_580)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_580-2",
    "data-name": "Ellipse 580",
    cx: 17.438,
    cy: 17.438,
    rx: 17.438,
    ry: 17.438,
    transform: "translate(12 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5654",
    "data-name": "Group 5654",
    transform: "translate(-9323.861 9266.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M280.682,193.38v2.755h4.556a4.34,4.34,0,0,1-4.556,3.469,5.074,5.074,0,0,1,0-10.147,4.515,4.515,0,0,1,3.2,1.242l2.18-2.1a7.7,7.7,0,0,0-5.388-2.1,8.036,8.036,0,1,0,0,16.073,7.523,7.523,0,0,0,7.717-7.855,7.337,7.337,0,0,0-.128-1.332h-7.589Z",
    transform: "translate(-272.64 -186.5)",
    fill: "#d13a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M314.011,197.4h-2.3v-2.3h-2.3v2.3h-2.3v2.3h2.3v2.3h2.3v-2.3h2.3Z",
    transform: "translate(-290.877 -190.517)",
    fill: "#d13a3c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCircle);
export default __webpack_public_path__ + "static/media/google-circle.cef5e7921a3497f472699d0238d4c455.svg";
export { ForwardRef as ReactComponent };